import { useQuery } from '@tanstack/react-query';
import { sessionQueries } from '../api/session-queries';

/** The current admin user. */
export function useSession() {
  return useQuery(sessionQueries.me());
}

/** The current user's role, or null while loading / unauthenticated. */
export function useCurrentRole(): string | null {
  const { data } = useSession();
  return data?.role ?? null;
}

/** The current user's id (for per-user prefs like status priority). */
export function useCurrentUserId(): number | string {
  const { data } = useSession();
  return data?.user_id ?? 'anon';
}
